var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80324_148406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.664062 4.00521C0.664062 2.16421 2.1564 0.671875 3.9974 0.671875C5.8384 0.671875 7.33073 2.16421 7.33073 4.00521C7.33073 5.84621 5.8384 7.33854 3.9974 7.33854C2.1564 7.33854 0.664062 5.84621 0.664062 4.00521ZM3.9974 2.67187C3.9974 2.58347 3.96228 2.49868 3.89976 2.43617C3.83725 2.37366 3.75247 2.33854 3.66406 2.33854C3.57566 2.33854 3.49087 2.37366 3.42836 2.43617C3.36585 2.49868 3.33073 2.58347 3.33073 2.67187V4.33854C3.33073 4.42695 3.36585 4.51173 3.42836 4.57424C3.49087 4.63676 3.57566 4.67187 3.66406 4.67187H5.33073C5.41913 4.67187 5.50392 4.63676 5.56643 4.57424C5.62894 4.51173 5.66406 4.42695 5.66406 4.33854C5.66406 4.25014 5.62894 4.16535 5.56643 4.10284C5.50392 4.04033 5.41913 4.00521 5.33073 4.00521H3.9974V2.67187Z",
    fill: "#FB2047"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80324_148406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFill);
export default __webpack_public_path__ + "static/media/clock-fill.6af477b405c8a768961f39f2c087c94f.svg";
export { ForwardRef as ReactComponent };